/**
 * @typedef module:Media.HlsVideoService.HlsLogTypeEnum
 * @description Every value emitted by a subscription to 'start' is tagged with one of these values,
 *     which clients can use to process the values
 * @property {String} autoPlay
 * @property {String} badParams
 * @property {String} builtInStart
 * @property {String} builtInStop
 * @property {String} codecError
 * @property {String} firstPacketReceived
 * @property {String} info
 * @property {String} init
 * @property {String} keepAliveConfirmed
 * @property {String} keepAliveFailed
 * @property {String} libDestroying
 * @property {String} libCreateInstanceConfirmed
 * @property {String} libCreateInstanceFailed
 * @property {String} libError
 * @property {String} libManifestParsed
 * @property {String} libMediaAttached
 * @property {String} videoError
 * @property {String} viewerSessionCreated
 * @property {String} viewerSessionFailed
 * @property {String} videoPlaying
 * @property {String} videoStalled
 */

const HlsLogTypeEnum = Object.freeze({
    autoPlay: 'autoPlay',
    badParams: 'badParams',
    builtInStart: 'builtInStart',
    builtInStop: 'builtInStop',
    codecError: 'codecError',
    firstPacketReceived: 'firstPacketReceived',
    info: 'info',
    init: 'init',
    keepAliveConfirmed: 'keepAliveConfirmed',
    keepAliveFailed: 'keepAliveFailed',
    libDestroying: 'libDestroying',
    libCreateInstanceConfirmed: 'libCreateInstanceConfirmed',
    libCreateInstanceFailed: 'libCreateInstanceFailed',
    libError: 'libError',
    libManifestParsed: 'libManifestParsed',
    libMediaAttached: 'libMediaAttached',
    videoError: 'videoError',
    viewerSessionCreated: 'viewerSessionCreated',
    viewerSessionFailed: 'viewerSessionFailed',
    videoPlaying: 'videoPlaying',
    videoStalled: 'videoStalled'
});

export default HlsLogTypeEnum;
